import React from "react";
import "./App.css";
import ProfileScreen from "./Screens/ProfileScreen/ProfileScreen";
import ReminderScreen from "./Screens/ReminderScreen/ReminderScreen";

function App() {
  return (
    <>
      <ProfileScreen />
      <ReminderScreen />
    </>
  );
}

export default App;
